exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".charts-header-tab-title-active .selected{border-bottom:4px solid #fff!important;margin-bottom:0;border-radius:15px;width:120%}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Systems/SettingsModal.vue"],"names":[],"mappings":"AACA,0CAEI,uCAA0C,AAC1C,gBAAmB,AACnB,mBAAoB,AACpB,UAAY,CACf","file":"SettingsModal.vue","sourcesContent":["\n.charts-header-tab-title-active .selected{\n    /* border-bottom: 4px solid white !important; */\n    border-bottom: 4px solid white !important;\n    margin-bottom: 0px;\n    border-radius: 15px;\n    width: 120%;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2132c3f7","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Systems/SettingsModal.vue
// module id = 2061
// module chunks = 3